<div class="flex flex-col h-full bg-background rounded-xl">
  <div class="p-6 overflow-y-auto">
    
    <div class="mb-6 p-4 bg-surface rounded-lg border border-border">
      <div class="flex justify-between items-center mb-2">
        <app-text variant="muted" size="sm">Load Total Amount</app-text>
        <span class="font-medium">{{ totalAmount | currency }}</span>
      </div>
    </div>

    <form [formGroup]="form" class="space-y-4">
      <app-form-field label="Payment Amount">
        <app-number-input
          formControlName="amount"
          placeholder="0.00"
          [min]="0.01">
        </app-number-input>
      </app-form-field>

      <app-form-field label="External Invoice Number" hint="Optional tracking number if invoiced externally">
        <app-input
          formControlName="invoiceNumber"
          placeholder="e.g. INV-1001">
        </app-input>
      </app-form-field>

      <app-form-field label="Payment Method" hint="Optional">
        <app-input
          formControlName="paymentMethod"
          placeholder="e.g. Check, ACH, Quickpay">
        </app-input>
      </app-form-field>

      <app-form-field label="Payment Date">
        <app-date-picker
          formControlName="paymentDate">
        </app-date-picker>
      </app-form-field>
    </form>
    
  </div>
  
  <div class="p-6 border-t border-border flex justify-end gap-3 bg-surface rounded-b-xl">
    <app-button variant="outline" (click)="close()">Cancel</app-button>
    <app-button variant="primary" (click)="save()" [disabled]="form.invalid || isSaving()">
      @if (isSaving()) {
        <lucide-icon name="loader-2" class="w-4 h-4 animate-spin mr-2"></lucide-icon>
        Saving...
      } @else {
        Mark as Paid
      }
    </app-button>
  </div>
</div>
